module.exports = __webpack_public_path__ + "assets/img/index-partner27.8e1e5de5.jpg";